import GuideCoGuideApproval from "src/pages/Guide/GuideCoGuideApproval";
import GuideList from "src/pages/Guide/GuideList";
import GuideRegistration from "src/pages/Guide/GuideRegistration";

export const guideRoutes = [
  { path: "/guide/registration", component: GuideRegistration },
  { path: "/guide/list", component: GuideList },
  { path: "/guide-co-guide-approval", component: GuideCoGuideApproval },
];
